import React from 'react';
import { Shield, Stethoscope, Heart, BookOpen } from 'lucide-react';
export function TrustBar() {
  const badges = [{
    icon: Shield,
    text: 'MD, FSSO'
  }, {
    icon: Stethoscope,
    text: 'Bariatric & General Surgery / Cirugía bariátrica y general'
  }, {
    icon: Heart,
    text: 'Patient-centered care / Atención centrada en el paciente'
  }, {
    icon: BookOpen,
    text: 'Evidence-based approach / Enfoque basado en evidencia'
  }];
  return <section className="bg-slate-100 border-b border-slate-200 py-8" data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-206">
          {badges.map((badge, index) => <div key={index} className="flex items-center justify-center sm:justify-start space-x-3 text-center sm:text-left" data-id="element-207">
              <div className="flex-shrink-0 bg-white p-2 rounded-lg shadow-sm text-teal-600" data-id="element-208">
                <badge.icon className="w-6 h-6" data-id="element-209" />
              </div>
              <span className="text-sm font-medium text-slate-700 leading-tight" data-id="element-210">
                {badge.text}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}